import { HttpParams, HttpClient } from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { LastActions, LastActive, LastReservations, LastVisited } from '../models/lastActions';
import { HelperService } from './helper.service';
import {CITY} from "../tokens";

@Injectable({
  providedIn: 'root'
})
export class MainService {
  city: string;
  constructor(
    private helperService: HelperService,
    private http: HttpClient,
    @Inject(CITY) private injectedCity: string) {
      this.city = this.injectedCity || this.helperService.getCity();
  }

  getCriterias(): Observable<any> {
    const params = new HttpParams()
      .set("city", this.city)
      .set("action", "ListingCriteria");

    return this.http.get(environment.MOBIBLE_API_URL, { params: params });
  }

  getLastActions(): Observable<any> {
    const params = new HttpParams()
      .set("city", this.city)
      .set("action", "getLastActivity");

    return this.http
      .get(environment.MOBIBLE_API_URL, { params: params })
      .pipe(map(result => this.mapLastActions(result['response'])));
  }

  getCurrentOffersAndVenues(): Observable<any> {
    const params = new HttpParams()
      .set("city", this.city)
      .set("action", "ZavedeniaAppFirstPage")
      .set("type", "OnlyBanners");

    return this.http.get(environment.MOBIBLE_API_URL, { params: params });
  }

  getPosition(): Promise<any> {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resp => {
        resolve({ lng: resp.coords.longitude, lat: resp.coords.latitude });
      },
        err => {
          reject(err);
        });
    });
  }

  private mapLastActions(input): LastActions {
    const lastActive = input['lastActions'] || [];
    const lastVisited = input['lastVisitedVenues'] || [];
    const lastReservations = input['lastReservations'] || [];

    const lastActions: LastActions = {
      active: lastActive.map(x => <LastActive>{
        id: Number(x['zavedenia_id']),
        visited: x['datetime'],
        name: x['zavedenie'],
        name_uk: x['zavedenie_uk'],
      }),
      visited: lastVisited.map(x => <LastVisited>{
        id: Number(x['zavedenia_id']),
        visited: x['visit_datetime'],
        name: x['zavedenie'],
        name_uk: x['zavedenie_uk'],
      }),
      reservations: lastReservations.map(x => <LastReservations>{
        id: Number(x['zavedenia_id']),
        visited: x['datetime'],
        name: x['zavedenie'],
        name_uk: x['zavedenie_uk']
      })
    };

    return lastActions;
  }
}
